import * as React from 'react';

// Utils
import { isNilOrEmpty } from '@src/shared/src/util/general';
import { useTranslation } from 'react-i18next';
// Constants
// Actions
// Models
import { TechnicalStopModel } from '@src/shared/src/models';
// Interfaces
// Components
// Styles
import './styles/TechnicalStops.scss';

type Props = {
  technicalStops?: TechnicalStopModel[];
};

const TechnicalStops: React.FC<Props> = ({ technicalStops }) => {
  const { t } = useTranslation();

  if (isNilOrEmpty(technicalStops)) {
    return null;
  }

  return (
    <>
      {technicalStops.map((stop, i) => (
        <div className="technical-stops" key={`technical-stop-${i}`}>
          <i className="material-symbols">airline_stops</i>
          {t('technicalStop.label', { location: stop.location, duration: stop.duration })}
        </div>
      ))}
    </>
  );
};

export default TechnicalStops;
